export default __webpack_public_path__ + "static/img_3_376-f0e4415abd66dd0dfd29b6b2e048318a.jpg";